import { mobiClient, vipClient } from '@/services/axiosConfig'
import { CheckReferralRes, CreateInstanceReq, CreateInstanceReqVip, CreditLimitToggleRes, GetPackageListReq, InstancePackage, InstancePackageShift, PackageListRes, PackageSavePackageInfoReq, SaveContactInfoReqV3, SelectPackageReq, SelectPackageRes, SetSignatureReqV2, TanConfirmReqV3, TanConfirmResV2, TanCreateResV2, TanSendReq, VipCreate, VipValidate } from './types'

export const createTanNumber = async (
  req: TanSendReq
): Promise<TanCreateResV2 | undefined> => {
  try {
    const res = await mobiClient.post('/packageshift/tancreate', req)
    return res.data
  } catch (e) {
    console.error(e)
  }
}
export const createTanEmail = async (
  req: TanSendReq
): Promise<TanCreateResV2 | undefined> => {
  try {
    const res = await mobiClient.post('/packageshift/tancreate', req)
    return res.data
  } catch (e) {
    console.error(e)
  }
}
export const confirmTanV3 = async (
  req: TanConfirmReqV3
): Promise<TanConfirmResV2 | undefined> => {
  try {
    const res = await mobiClient.post('/packageshift/tanconfirm', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
export const savePackageInfoV2 = async (
  req: PackageSavePackageInfoReq,
  channel: string
): Promise<InstancePackage | undefined> => {
  try {
    const res = await mobiClient.post('/packageshift/savepackageinfo', req, {
      headers: { channel }
    })
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const saveContactV3 = async (
  req: SaveContactInfoReqV3
): Promise<InstancePackage | undefined> => {
  try {
    const res = await mobiClient.post('/packageshift/savecontactinfo', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const createInstance = async (
  req: CreateInstanceReq
): Promise<InstancePackageShift | undefined> => {
  try {
    const res = await mobiClient.post('/packageshift/create', req)
    return res.data
  } catch (e: any) {
    console.error(e)
    return e?.response?.data
  }
}

export const getPackageList = async (req: GetPackageListReq): Promise<PackageListRes | undefined> => {
  try {
    const res = await mobiClient.post('/packageshift/list', req)
    return res.data
  } catch (e) {
    console.error(e)
  }
}

export const selectPackage = async (req: SelectPackageReq): Promise<SelectPackageRes | undefined> => {
  const res = await mobiClient.post('/packageshift/selectpackage', req)
  return res.data
}

export const getInfo = async (
  instanceId: string
): Promise<InstancePackage | undefined> => {
  try {
    const res = await mobiClient.get(
      'packageshift/getinfo?instanceId=' + instanceId
    )
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const sendSign = async (
  req: SetSignatureReqV2
): Promise<InstancePackage | undefined> => {
  try {
    const res = await mobiClient.post('/packageshift/sign', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const checkReferralCode = async (referralCode: string, isdn: string, instanceId: string): Promise<CheckReferralRes | undefined> => {
  try {
    const res = await mobiClient({
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      },
      url: `/referralpromo/check-refcode?isdn=${isdn}&referralCode=${referralCode}&promoCode=REFERRAL-PROMO&type=PACKAGE-SHIFT&instanceId=${instanceId}`
    })
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const creditLimitPackageShiftToggle = async (
  isdn: string,
  action: string,
  instanceId: string,
  amount: number
): Promise<CreditLimitToggleRes | undefined> => {
  try {
    const res = await mobiClient.post('/subscription/credit-limit/toggle', {
      isdn,
      action,
      amount,
      instanceId
    })
    return res.data
  } catch (e: any) {
    console.error('creditLimitToggle error', e)
    return e?.response?.data
  }
}

export const vipShiftValidate = async (instanceId: string): Promise<VipValidate | undefined> => {
  try {
    const res = await vipClient.post('/packageshift/vip/validate', {
      resourceId: instanceId,
      channel: 'mobicom_web'
    })

    return res?.data
  } catch (e: any) {
    return e.response.data
  }
}

export const vipCreateInstance = async (req: CreateInstanceReqVip): Promise<VipCreate | undefined> => {
  try {
    const res = await vipClient.post('/packageshift/vip/create', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}